import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2, toJS} from '@api'
import {Button, Icon, Menu, MenuDivider} from '@blueprintjs/core'
import {ContextMenuItem, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {MyImage} from 'centric-ui-components'
import * as css from './AssortmentCatalogSwatchGlobalChooser.css'

/// region Store

export class AssortmentCatalogSwatchGlobalChooserStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @computed get availableSwatches() {
    const {catalog: {idFor, assortments: {roots}}} = this

    const r = _.uniqBy(
      _.flatMap(roots.flatMap(r => r.cardStores.map(s => s.componentStores.swatches?.swatches))).filter(_.identity),
      v => v.item.name)

    // console.log(r)
    return r
  }

  @computed get selectedSwatch() {
    const {catalog: {settings: {assortment: {swatches: {globalSelected}}}}} = this

    if (!globalSelected) return null
    return this.availableSwatches.find(s => s?.item?.name === globalSelected)
  }
}

export const AssortmentCatalogSwatchGlobalChooserStoreContext = React.createContext<AssortmentCatalogSwatchGlobalChooserStore>(null)
export const useAssortmentCatalogSwatchGlobalChooserStore = () => React.useContext(AssortmentCatalogSwatchGlobalChooserStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const AssortmentCatalogSwatchGlobalChooser = observer<MyProps>(function AssortmentCatalogSwatchGlobalChooser({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new AssortmentCatalogSwatchGlobalChooserStore(stores, obsProps)),
    {availableSwatches, selectedSwatch, stores: {catalog: {imageUrlFor, settings: {assortment: {swatches, swatches: {globalSelected}}}, assortments: assortmentsStore, assortments: {selectedAssortment, roots}}}} = store

  useEffect(() => store.registerEffects(), [])

  if (_.isEmpty(availableSwatches)) return null
  return (
    <AssortmentCatalogSwatchGlobalChooserStoreContext.Provider value={store}>
      <Popover2
        interactionKind='hover'
        position='top-left'
        className={classNames(css.root, className)}
        content={<Menu className={css.popoverContents}>
          {availableSwatches.map(({item}, i) => (
            <ContextMenuItem
              icon={<MyImage
                imageId={assortmentsStore.swatchImageFor(item)?.exId}
                src={assortmentsStore.swatchImageUrlFor(item)}/>}
              onClick={() => {
                swatches.globalSelected = swatches.globalSelected == item.name ? undefined : item.name
              }}
              text={item.name}
              key={i}
              labelElement={<Icon icon={globalSelected && globalSelected === item.name ? 'tick' : 'blank'}/>}
            />))}
          <MenuDivider />
          <ContextMenuItem
            icon='blank'
            text='Clear Selection'
            disabled={swatches.globalSelected == null}
            onClick={() => swatches.globalSelected = undefined}
            //labelElement={<Icon icon={globalSelected === null ? 'tick' : 'blank'}/>}
          />
        </Menu>}
      >
        <div className={css.selectedSwatch}>
          <Button minimal
                  icon={
                    !selectedSwatch
                    ? undefined
                    : <MyImage
                      imageId={assortmentsStore.swatchImageFor(selectedSwatch.item)?.exId}
                      src={assortmentsStore.swatchImageUrlFor(selectedSwatch.item)}/>}
                  text={selectedSwatch?.item?.name ?? 'Select Colorway...'} rightIcon='caret-down'/>
        </div>
      </Popover2>
    </AssortmentCatalogSwatchGlobalChooserStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCatalogSwatchGlobalChooser.tsx